import { useEffect, useState, useContext, useRef } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2'
ChartJS.register(...registerables);

interface ChartProps {
    labels?: Array<string>,
    datasets: Array<ChartDatasetProps>
}

interface ChartDatasetProps {
    label: string,
    data: Array<number>,
    bgColor: string,
    borderColor?: string,
}

interface ChartDataset {
    label: string,
    data: Array<number>,
    backgroundColor: string,
    barThickness: number,
    borderColor: string,
    borderWidth: number,
    borderRadius: number,
}

export const StackedBarChart: React.FC<ChartProps> = ({datasets, labels}) => {
    const screenRef = useRef(false)
    const [chartDataset, setChartDataset] = useState<Array<ChartDataset>>(
        [
            {
                label: '# of age',
                data: [20, 30,19],
                backgroundColor: 'green',
                barThickness: 40,
                borderColor: 'green',
                borderWidth: 1,
                borderRadius: 11
            }
        ]
    )

    useEffect(() => {
        handlDataFormatting()
        screenRef.current = window.matchMedia('(max-width: 470px)').matches
    }, [datasets])

    function handlDataFormatting () {
        let info = []

        for (let item of datasets) {
            info.push({
                label: item.label,
                data: item.data,
                backgroundColor: item.bgColor,
                barThickness: screenRef.current ? 12 : 25,
                borderColor: item.borderColor || item.bgColor,
                borderWidth: 1,
                borderRadius: screenRef.current ? 3 : 5,
            })
        }

        setChartDataset(info)
    }

    return (
        <Bar 
            data={{
                labels: labels || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: chartDataset
            }}
            height="100%"
            width="100%"
            options={{
                maintainAspectRatio: false, 
                plugins: {
                    legend: {
                        align: 'start',
                        //display: false,
                        labels: {
                            boxWidth: 6,
                            usePointStyle: true,
                            boxHeight: 6,
                            color: '#667085',
                            font: {
                                size: 14
                            }
                        }
                    }
                },
                scales: {
                    y: {  
                        stacked: true,
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3
                        },
                        ticks: {
                            color: "#111111",
                            display: false
                        },
                        //max: 60000
                    },
                    x: {  
                        stacked: true,
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3,
                        },
                        ticks: {
                            color: "#667085",
                            font: {
                                size: screenRef.current ? 8 : 12
                            } 
                        },
                    }
                }
            }}
        />
    )
}
